export default function comment(
  { UserID, ReferenceType, Comment, ReferenceID },
  ParentID = null
) {
  const comment = {
    UserID,
    ParentID,
    ReferenceID,
    Comment,
    ReferenceType
  };

  return Object.freeze(comment);
}
